// Constructor
function GardenGame(app) {
	this.app = app;
	this.flowers = [];
	this.numFlowers = 9;

	this.started = false;

	this.waterTankMaxLevel = 9;
	this.waterTankLevel = this.waterTankMaxLevel;
	this.addWaterQuantity = 1;

	this.flowerLevels = [0, 0, 0, 1, 0, 1, 1, 2, 2];
}

GardenGame.prototype.init = function () {
	console.log("game init")

	this.flowerLevels = shuffle(this.flowerLevels);

	for (var i = 0; i < this.numFlowers; i++) {
		this.flowers.push(new GardenFlower(this.app, this, $("#grid-" + (i + 1)), i, this.flowerLevels[i]));
		setTimeout($.proxy(function () {
			this.show();
		}, this.flowers[i]), Math.random() * 500 + 100);
	}

	$(".gauge.shown").data("current-level", $(".gauge.shown").data("max-level"));

	this.resetWaterTank();

	setTimeout($.proxy(function () {
		this.startGame();
	}, this), 1000);
}

GardenGame.prototype.startGame = function () {
	this.started = true;
};

GardenGame.prototype.endGame = function () {
	this.started = false;
	this.showResults();
};

GardenGame.prototype.addWater = function (index) {

	// Enable continue button
	$("#game #main.my-garden .screen .section-right .specific.game .big-button").removeClass("disabled");

	// Apply water
	// if (this.waterTankLevel > 0 && this.flowers[index].waterLevel <2) {
	if (this.waterTankLevel > 0 ) {
		this.waterTankLevel -= this.addWaterQuantity;
		this.animateWaterTank();
		this.flowers[index].updateWaterLevel(this.addWaterQuantity);

		// If there is no more water, go to result
		if (this.waterTankLevel <= 0) {
			this.app.goToResult();
		}
	}

};

GardenGame.prototype.resetWaterTank = function () {
	var maxLevel = $(".gauge.shown").data("max-level");
	$(".gauge .gauge-level").css({bottom: maxLevel});
	$(".gauge.shown").data("current-level", maxLevel);
}

GardenGame.prototype.animateWaterTank = function () {
	var currentLevel = $(".gauge.shown").data("current-level");
	var maxLevel = $(".gauge.shown").data("max-level");
	var minLevel = $(".gauge.shown").data("min-level");
	var step = (maxLevel - minLevel) / (this.waterTankMaxLevel / this.addWaterQuantity);
	var nextLevel = currentLevel - step;

	$(".gauge .gauge-level").css({bottom: nextLevel});
	$(".gauge.shown").data("current-level", nextLevel);
};

GardenGame.prototype.getResult = function () {

	// Calculate total score
	var totalLevel = 0;
	var maximum = 2 * 9;
	for (var i = 0; i < this.numFlowers; i++) {
		totalLevel += this.flowers[i].waterLevel;
	}
	var points = (totalLevel / maximum);

	// console.log(points, totalLevel , maximum)

	// Give result according to score
	if (points > 0.88) {
		return "c";
	} else if (points > 0.67) {
		return "b";
	} else {
		return "a";
	}
}

GardenGame.prototype.showResults = function () {

	// Go to result mode
	for (var i = 0; i < this.numFlowers; i++) {
		this.flowers[i].result();
	}
};

GardenGame.prototype.reset = function () {

	// Destroy flowers
	for (var i = (this.numFlowers - 1); i >= 0; i--) {
		if (this.flowers[i]) {
			this.flowers[i].destroy();
			this.flowers.pop();
		}
	}

	$("#grid").removeClass("result");

	// Disable continue button
	$("#game #main.my-garden .screen .section-right .specific.game .big-button").addClass("disabled");

	this.waterTankLevel = this.waterTankMaxLevel;
}

// Expose Garden
window.GardenGame = GardenGame;

